import React from 'react';
import { ControlKeyType, MoveKeyType } from '../../container/noshi';
import { t } from '../../localize';

type Props = {
  onClickTitle: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onClickSize: (key: ControlKeyType) => void;
  onClickMove: (key: MoveKeyType) => void;
};

export const Controller: React.FC<Props> = ({
  onClickTitle,
  onClickSize,
  onClickMove,
}) => {
  return (
    <ul>
      {/* 表書き */}
      <li className='c_size_all green'>
        <span>{'表書き'}</span>
        <button className='c_left' name={'size-small'} onClick={onClickTitle}>
          {t('noshiControllerSmall')}
        </button>
        <button className='c_center' name={'size-big'} onClick={onClickTitle}>
          {t('noshiControllerBig')}
        </button>
        <button className='c_right' name={'size-reset'} onClick={onClickTitle}>
          {t('noshiControllerClose')}
        </button>
      </li>
      <li className='c_move green'>
        <button className='c_top' name={'title-up'} onClick={onClickTitle}>
          {t('noshiControllerUp')}
        </button>
        <button className='c_bottom' name={'title-down'} onClick={onClickTitle}>
          {t('noshiControllerDown')}
        </button>
        <button className='c_left' name={'title-left'} onClick={onClickTitle}>
          {t('noshiControllerLeft')}
        </button>
        <button className='c_right' name={'title-right'} onClick={onClickTitle}>
          {t('noshiControllerRight')}
        </button>
        <button className='c_reset' name={'title-reset'} onClick={onClickTitle}>
          {t('noshiControllerClose')}
        </button>
      </li>

      {/* 名入れ3 */}
      <li className='c_size_all'>
        <span>{t('noshiControllerNaire3')}</span>
        <button className='c_left' onClick={(_) => onClickSize('3-small')}>
          {t('noshiControllerSmall')}
        </button>
        <button className='c_center' onClick={(_) => onClickSize('3-big')}>
          {t('noshiControllerBig')}
        </button>
        <button className='c_right' onClick={(_) => onClickSize('3-reset')}>
          {t('noshiControllerClose')}
        </button>
      </li>
      <li className='c_move'>
        <button className='c_top' onClick={(_) => onClickMove('naire3-up')}>
          {t('noshiControllerUp')}
        </button>
        <button
          className='c_bottom'
          onClick={(_) => onClickMove('naire3-down')}
        >
          {t('noshiControllerDown')}
        </button>
        <button className='c_left' onClick={(_) => onClickMove('naire3-left')}>
          {t('noshiControllerLeft')}
        </button>
        <button
          className='c_right'
          onClick={(_) => onClickMove('naire3-right')}
        >
          {t('noshiControllerRight')}
        </button>
        <button
          className='c_reset'
          onClick={(_) => onClickMove('naire3-reset')}
        >
          {t('noshiControllerClose')}
        </button>
      </li>

      {/* 名入れ2 */}
      <li className='c_size_all'>
        <span>{t('noshiControllerNaire2')}</span>
        <button className='c_left' onClick={(_) => onClickSize('2-small')}>
          {t('noshiControllerSmall')}
        </button>
        <button className='c_center' onClick={(_) => onClickSize('2-big')}>
          {t('noshiControllerBig')}
        </button>
        <button className='c_right' onClick={(_) => onClickSize('2-reset')}>
          {t('noshiControllerClose')}
        </button>
      </li>
      <li className='c_move'>
        <button className='c_top' onClick={(_) => onClickMove('naire2-up')}>
          {t('noshiControllerUp')}
        </button>
        <button
          className='c_bottom'
          onClick={(_) => onClickMove('naire2-down')}
        >
          {t('noshiControllerDown')}
        </button>
        <button className='c_left' onClick={(_) => onClickMove('naire2-left')}>
          {t('noshiControllerLeft')}
        </button>
        <button
          className='c_right'
          onClick={(_) => onClickMove('naire2-right')}
        >
          {t('noshiControllerRight')}
        </button>
        <button
          className='c_reset'
          onClick={(_) => onClickMove('naire2-reset')}
        >
          {t('noshiControllerClose')}
        </button>
      </li>

      {/* 名入れ1 */}
      <li className='c_size_all'>
        <span>{t('noshiControllerNaire1')}</span>
        <button className='c_left' onClick={(_) => onClickSize('1-small')}>
          {t('noshiControllerSmall')}
        </button>
        <button className='c_center' onClick={(_) => onClickSize('1-big')}>
          {t('noshiControllerBig')}
        </button>
        <button className='c_right' onClick={(_) => onClickSize('1-reset')}>
          {t('noshiControllerClose')}
        </button>
      </li>
      <li className='c_move'>
        <button className='c_top' onClick={(_) => onClickMove('naire1-up')}>
          {t('noshiControllerUp')}
        </button>
        <button
          className='c_bottom'
          onClick={(_) => onClickMove('naire1-down')}
        >
          {t('noshiControllerDown')}
        </button>
        <button className='c_left' onClick={(_) => onClickMove('naire1-left')}>
          {t('noshiControllerLeft')}
        </button>
        <button
          className='c_right'
          onClick={(_) => onClickMove('naire1-right')}
        >
          {t('noshiControllerRight')}
        </button>
        <button
          className='c_reset'
          onClick={(_) => onClickMove('naire1-reset')}
        >
          {t('noshiControllerClose')}
        </button>
      </li>

      {/* 名入れ全体 */}
      <li className='c_size_all'>
        <span>{t('noshiControllerNaireAll')}</span>
        <button className='c_left' onClick={(_) => onClickSize('all-small')}>
          {t('noshiControllerSmall')}
        </button>
        <button className='c_center' onClick={(_) => onClickSize('all-big')}>
          {t('noshiControllerBig')}
        </button>
        <button className='c_right' onClick={(_) => onClickSize('all-reset')}>
          {t('noshiControllerClose')}
        </button>
      </li>
      <li className='c_move'>
        <button className='c_top' onClick={(_) => onClickMove('up')}>
          {t('noshiControllerUp')}
        </button>
        <button className='c_bottom' onClick={(_) => onClickMove('down')}>
          {t('noshiControllerDown')}
        </button>
        <button className='c_left' onClick={(_) => onClickMove('left')}>
          {t('noshiControllerLeft')}
        </button>
        <button className='c_right' onClick={(_) => onClickMove('right')}>
          {t('noshiControllerRight')}
        </button>
        <button className='c_reset' onClick={(_) => onClickMove('reset')}>
          {t('noshiControllerClose')}
        </button>
      </li>
    </ul>
  );
};
